<template>
  <div class="component-wrapper row g-0">
    <div class="col-md-6 col-12 d-flex justify-content-center image-wrapper">
      <img :src="'/storage/' + imageUrl" alt="" class="mock-image">
    </div>

    <div class="col-md-6 col-12 d-flex align-items-center content-wrapper">
      <div>
        <div class="compare-title">{{ title }}</div>
        <div class="category mt-2"> {{ category }}</div>
        <div v-if="description" class="description-container">
          <p class="fade-out">
            {{ description }}
          </p>
        </div>
        <a v-if="description" href="#" @click.prevent="scrollToFullDescription">{{ $t('learn-more') }}</a>
        <div class="contact-details mt-4 mb-4">
          <div>Email: {{ email }}</div>
          <div>
            <a :href="'tel:' + phone" class="phone-number">{{ $t('phone') }}: {{ phone }}</a>
          </div>
        </div>
        <div v-if="booking.hasOwnProperty('uin') && booking.uin" class="d-flex mt-3">
          <a :href="$router.resolve(bookAppointmentLink).href">
            <MainButton :button-text="$t('book-appointment-online')" :icon="'calendar'" :size="'medium-large'"
                        :theme="'solid-blue'"/>
          </a>

        </div>

      </div>
    </div>
  </div>
</template>


<script>
import MainButton from "@/components/Common/Buttons/MainButton.vue";


export default {
  name: 'OneOfficeHeadingComponent',
  components: {
    MainButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
      default: "mc.sofia@unihospitalbg.bg"
    },
    phone: {
      type: String,
      required: true,
      default: "0884 64 87 11"
    },
    buttonText: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    booking: {
      type: Object,
      default: null,
    },
  },
  computed: {
    bookAppointmentLink() {
      const link = {name: 'BookAppointmentView'}
      if (this.$props.booking) {
        link['query'] = {
          phys: this.$props.booking.uin,
          hosp: this.$props.booking.hosp,
          spec: this.$props.booking.spec,
        };
      }
      return link;
    }
  },
  methods: {
    scrollToFullDescription() {
      this.$emit('scroll-to-full-description');
    },
  },
};
</script>


<style lang="scss" scoped>
.component-wrapper {
  color: $color-brown;
  border-radius: 30px;

  .image-wrapper {
    background: $color-blue-light;
    border-radius: 30px;
    height: 484px;
  }


  .content-wrapper {
    margin-top: 20px;
    border-radius: 30px;
    padding: 30px;
    background: $color-light-brown;

    a {
      color: $color-brown;
      font-family: $font-bold;
      text-decoration: none;
    }

    .phone-number {
      font-family: $font-regular !important;
    }

    .category {
      font-size: $subtitle-1;
    }

    .compare-title {
      font-size: $title-h4;
      line-height: $title-h4;
      font-family: $font-bold;
    }

    .description-container {
      margin: $spacing-5 0 $spacing-1;
      font-size: $paragraph-1;
      line-height: $paragraph-1-lh;
      position: relative;
      overflow: hidden;

      .fade-out {
        position: relative;
        height: 100px;
        mask-image: linear-gradient(180deg, rgba(0, 0, 0, 1) 1%, rgba(0, 0, 0, 0));
        -webkit-mask-image: linear-gradient(180deg, rgba(0, 0, 0, 1) 1%, rgba(0, 0, 0, 0));
      }
    }
  }


  .mock-image {
    transform: translateY(-6%);
    height: 515px;
  }
}

@media screen and (min-width: 768px) {
  .component-wrapper {
    border-radius: 50px;
    height: 680px;
    overflow: hidden;
    background: $color-blue-light;

    .content-wrapper {
      padding: 150px 80px;
      background: $color-blue-light;

      .compare-title {
        font-size: $title-h3;
        line-height: 40px;
      }
    }


    .mock-image {
      height: 740px;
      position: absolute;
      transform: translateY(-8.3%);
    }
  }
}
</style>



